import React, { Suspense, useEffect } from 'react'
import {
  Route,
  Switch
} from 'react-router-dom'
import PrivateRoute from 'components/PrivateRoute'
import AdminRoute from 'components/AdminRoute'
import Loader from 'components/Loader'
import { useDispatch } from 'react-redux'
import notificationsConnection, { closeWebsocketConnection } from 'utils/notifications/notificationsConnection'
import { getUserInfo } from 'utils/auth/actions'


const LoginPage = React.lazy(() => import('containers/LoginPage'))
const RegisterPage = React.lazy(() => import('containers/RegisterPage'))
const AccountRecovery = React.lazy(() => import('containers/AccountRecovery'))
const PasswordResetLink = React.lazy(() => import('containers/PasswordResetLink'))
const CreateWorkspacePage = React.lazy(() => import('containers/CreateWorkspacePage'))
const ActivateAccountPage = React.lazy(() => import('containers/ActivateAccountPage'))

const DatabasePage = React.lazy(() => import('containers/DatabasePage'))
const CalendarPage = React.lazy(() => import('containers/CalendarPage'))
const DocumentsPage = React.lazy(() => import('containers/DocumentsPage'))
const SettingsPage = React.lazy(() => import('containers/SettingsPage'))
// const AdvicePage = React.lazy(() => import('containers/AdvicePage'))
const AdvicePreviewPage = React.lazy(() => import('containers/AdvicePreviewPage'))
const LawsPage = React.lazy(() => import('containers/LawsPage'))
const LegalUpdatesPage = React.lazy(() => import('containers/LegalUpdatesPage'))

// detail pages
const LegalUpdatePreviewPage = React.lazy(() => import('containers/LegalUpdatePreviewPage'))
const RequestPreviewPage = React.lazy(() => import('containers/RequestPreviewPage'))
const ActionPage = React.lazy(() => import('containers/ActionPage'))
const LawPage = React.lazy(() => import('containers/LawPage'))
const GroupPage = React.lazy(() => import('containers/GroupPage'))
const LegalChangeCollectionPage = React.lazy(() => import('containers/LegalChangeCollectionPage'))

// admin
const GroupsPage = React.lazy(() => import('containers/GroupsPage'))
const RequestsPage = React.lazy(() => import('containers/RequestsPage'))
const LegalChangesPage = React.lazy(() => import('containers/LegalChangesPage'))

// dev
const Page404 = React.lazy(() => import('containers/Page404'))
const TestPage = React.lazy(() => import('containers/TestPage'))


const Routes = (props) => {
  const { authToken, userType, activeWorkspace } = props
  const dispatch = useDispatch()

  useEffect(() => {
    if (authToken) {
      dispatch(notificationsConnection())
      dispatch(getUserInfo())
    } else {
      closeWebsocketConnection()
    }
    return () => {
      closeWebsocketConnection()
    }
  }, [authToken]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path='/login' component={LoginPage} />
        <Route exact path='/register' component={RegisterPage} />
        <Route exact path='/account-recovery' component={AccountRecovery} />
        <Route exact path='/password-reset' component={PasswordResetLink} />
        <Route exact path='/activate-account' component={ActivateAccountPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='create-workspace' component={CreateWorkspacePage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/' component={LegalUpdatesPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/advices' component={DatabasePage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/action-plan' component={CalendarPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/documents' component={DocumentsPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/laws' component={LawsPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/requests' component={RequestsPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/settings' component={SettingsPage} />

        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/legal-changes/:legalChangeId' component={LegalUpdatePreviewPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/legal-change-collection/:legalChangeId' component={LegalChangeCollectionPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/requests/:requestId' component={RequestPreviewPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/action-plan/:startDate' component={ActionPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/laws/:lawId' component={LawPage} />
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/groups/:groupId' component={GroupPage} />

        <AdminRoute userType={userType} authToken={authToken} activeWorkspace={activeWorkspace} exact path='/legal-changes' component={LegalChangesPage} />
        <AdminRoute userType={userType} authToken={authToken} activeWorkspace={activeWorkspace} exact path='/groups' component={GroupsPage} />
        { process.env.NODE_ENV === 'development' ?
          <PrivateRoute authToken={authToken} exact path='/test' component={TestPage} /> : null}
        <PrivateRoute authToken={authToken} activeWorkspace={activeWorkspace} exact path='/advices/:adviceId' component={AdvicePreviewPage} />

        <Route exact path='/:path' component={Page404} />
      </Switch>
    </Suspense>
  )
}

export default Routes
